import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  examHomePage: true,      // Exam selection home
  evaluatorPage: false,    // AI Evaluator intro flow
  examFlowPage: false,     // Full exam flow (intro, recording, results)
  welcomePage: false,      // Legacy: Skill intro/instructions
  campaignPage: false,     // Legacy: Video recording
  thirdChoicePage: false,
  webinarPage: false,
  resultsPage: false,
};

export const pageSlice = createSlice({
  name: "page",
  initialState,
  reducers: {
    pageChange: (state, action) => {
      Object.keys(state).forEach((key) => {
        if (action.payload.page === key) {
          state[key] = true;
        } else {
          state[key] = false;
        }
      });
    },
  },
});

export const { pageChange } = pageSlice.actions;

export const pages = (state) => state.page;

export default pageSlice.reducer;
